<style scoped>
@import url(../../style/home/homepage.css);
@import url(../../style/home/product-section.css);
@import url(../../style/home/product-section-hover.css);

/* 产品详情页面的头部样式 */
.header.header-scrolled.product-detail {
  background-color: #054994;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* 确保产品详情页导航栏在滚动时保持蓝色背景 */
.header.product-detail {
  background-color: #054994;
}

/* 产品详情页面的导航栏文字颜色，确保始终为白色 */
.header.product-detail .nav a,
.header.product-detail .contact-lang a,
.header.product-detail.scrolled .nav a,
.header.product-detail.scrolled .contact-lang a {
  color: white !important;
}
</style>

<template>
  <div class="header-container">
    <!-- 头部导航 -->
    <header class="header" :class="{
      'header-scrolled': isScrolled,
      'product-detail': isSolidHeader
    }">
      <!-- 联系我们和语言选择放在最顶部 -->
      <!-- <div class="contact-lang">
        <a href="#">联系我们</a>
        <a href="#">English</a>
      </div> -->

      <!-- logo和导航部分 -->
      <div class="logo">
        <img
          :src="useWhiteLogo ? require('@/assets/images/appheader/logo-white.png') : require('@/assets/images/appheader/logo.png')"
          alt="千手医疗logo" title="千手医疗" />
      </div>
      <nav class="nav">
        <ul>
          <li><router-link to="/" active-class="active" @click="scrollToTop">首页</router-link></li>
          <li><a href="#" @mouseenter="toggleSubMenu('product')" @mouseleave="handleDropdownLeave">产品及应用</a></li>
          <li><router-link to="/innovative-manufacturing">创新智造</router-link></li>
          <li><router-link to="/party-mass-work" @click="scrollToTop">党群建设</router-link></li>
          <!-- <li><a href="#">用户服务</a></li>
          <li><a href="#">人才计划</a></li> -->
          <!-- <li><a href="#">家用医疗</a></li> -->
          <li><router-link to="/about-us" @click="scrollToTop">关于我们</router-link></li>
          <!-- <li class="search-icon">
            <a href="#">
              <img :src="require('@/assets/images/search.png')" alt="搜索" />
            </a>
          </li> -->
        </ul>
      </nav>
    </header>

    <!-- 产品及应用鼠标悬浮显示区域 -->
    <div class="menu-wrapper" :class="{ 'menu-visible': visibleMenu }" @mouseenter="clearDropdownTimer"
      @mouseleave="handleDropdownLeave">
      <!-- 一级菜单 -->
      <div class="menu-level1">
        <div
          class="menu-item level1"
          @mouseenter="toggleSubMenu('product')"
          @click="navigateToProductCenter"
        >
          产品中心
        </div>
        <div
          class="menu-item level1"
          @mouseenter="toggleSubMenu('solution')"
          @click="navigateToFumeiApp"
        >
          移动应用
        </div>
      </div>

      <!-- 二级+三级菜单 悬浮容器：产品中心 -->
      <div class="sub-menu-container" v-show="visibleMenu === 'product'">
        <!-- 二级菜单 -->
        <div class="menu-level2">
          <div v-for="(item, idx) in productMenu" :key="idx" class="menu-item level2" @mouseenter="toggleThirdMenu(idx)"
            @click="navigateToProductCategory(idx)">
            {{ item.title }}
          </div>
        </div>
        <!-- 三级菜单 -->
        <div class="menu-level3">
          <ul v-if="activeThirdIdx !== -1">
            <li v-for="(prod, pIdx) in productMenu[activeThirdIdx].products" :key="pIdx" class="third-level-item"
              @click="navigateToProduct(prod)">
              <span class="bullet">•</span> {{ prod }}
            </li>
          </ul>
        </div>
      </div>

      <!-- 二级菜单：移动应用 -->
      <div class="sub-menu-container" v-show="visibleMenu === 'solution'">
        <div class="menu-level2">
          <div class="menu-item level2" @click="navigateToFumeiApp">
            肤美APP
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      visibleMenu: '', // 控制显示"产品中心"或"应用方案"的悬浮菜单
      activeThirdIdx: -1, // 控制显示哪个二级菜单下的三级产品
      dropdownTimer: null,
      isScrolled: false, // 控制头部是否已滚动
      productMenu: [
        {
          title: '皮肤镜图像处理工作站',
          products: ['SMS-3000Ⅰ', 'SMS-3000Ⅱ', 'SMS-6000Ⅰ', 'SMS-3000Ⅱ']
        },
        {
          title: '皮肤科',
          products: ['触屏式皮肤镜', '手持式皮肤镜', '便携式皮肤镜']
        },
        {
          title: '医学美容科',
          products: ['面部检测仪', 'visia']
        },
        {
          title: '言语认知',
          products: ['便携式', '单屏幕', '平板式', '双屏']
        },
        {
          title: '消化内科',
          products: ['电子肠镜', '电子胃镜']
        },
        {
          title: '妇产科',
          products: ['4K电子阴道显微镜']
        }
      ]
    }
  },
  mounted() {
    // 初始状态设置为透明
    this.isScrolled = false;
    // 添加滚动事件监听
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    this.clearDropdownTimer();
    // 移除滚动事件监听
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    // 产品详情 / 肤美 / 资讯列表与详情：固定蓝底导航
    isSolidHeader() {
      return ['SpecificProducts', 'FumeiApp', 'NewsCenter', 'NewsDetail'].includes(this.$route.name)
    },
    // 固定蓝底，或首页未滚动时使用白色 logo
    useWhiteLogo() {
      return !this.isScrolled || this.isSolidHeader
    }
  },
  methods: {
    // 菜单相关方法
    toggleSubMenu(menu) {
      this.visibleMenu = menu
    },

    toggleThirdMenu(idx) {
      this.activeThirdIdx = idx
    },

    clearDropdownTimer() {
      if (this.dropdownTimer) {
        clearTimeout(this.dropdownTimer)
        this.dropdownTimer = null
      }
    },

    handleDropdownLeave() {
      this.dropdownTimer = setTimeout(() => {
        this.visibleMenu = ''
        this.activeThirdIdx = -1
      }, 300)
    },

    navigateToProduct(prod) {
      const speechProducts = ['便携式', '单屏幕', '平板式', '双屏']
      const productTitle = speechProducts.includes(prod) ? `言语认知${prod}` : prod

      this.visibleMenu = ''
      this.activeThirdIdx = -1
      this.$router.push({
        name: 'SpecificProducts',
        query: {
          productTitle,
          productModel: prod
        }
      });
    },

    // 点击「产品中心」进入产品列表页
    navigateToProductCenter() {
      this.visibleMenu = ''
      this.activeThirdIdx = -1
      window.scrollTo(0, 0)
      this.$router.push({ name: 'ProductApplication' })
    },

    // 导航到产品分类页面
    navigateToProductCategory(categoryIndex) {
      this.visibleMenu = ''
      this.activeThirdIdx = -1
      window.scrollTo(0, 0)
      this.$router.push({
        name: 'ProductApplication',
        params: {
          categoryIndex: categoryIndex.toString()
        }
      })
    },

    // 导航到肤美APP页面
    navigateToFumeiApp() {
      this.visibleMenu = ''
      this.activeThirdIdx = -1
      this.isScrolled = false
      window.scrollTo(0, 0)
      this.$router.push({ name: 'FumeiApp' })
    },

    // 滚动到顶部（与各页入场动画配合，使用 auto 避免打断过渡）
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'auto' })
    },

    // 处理滚动事件
    handleScroll() {
      // 产品详情页、肤美APP页保持蓝色导航，不随滚动切换
      if (this.$route.name === 'SpecificProducts' || this.$route.name === 'FumeiApp') {
        return;
      }

      // 如果是AboutUs页面，使用特定的滚动逻辑
      if (this.$route.name === 'AboutUs') {
        this.isScrolled = window.scrollY > 100;
        return;
      }

      // 检查是否在产品应用页面
      const isProductApplicationPage = this.$route.name === 'ProductApplication';

      if (isProductApplicationPage) {
        // 在产品应用页面，检查bottom-banner元素
        const bottomBanner = document.querySelector('.bottom-banner');
        if (bottomBanner) {
          // 获取banner元素的尺寸和位置
          const bannerRect = bottomBanner.getBoundingClientRect();
          // 当滚动距离超过banner底部位置时，修改头部样式为白色背景
          // 当banner底部完全离开视口顶部时（即bannerRect.bottom < 0），设置isScrolled为true
          this.isScrolled = bannerRect.bottom < 0;
        }
      } else {
        // 在其他页面，使用原有的逻辑
        const mainContent = document.querySelector('.main-content');
        if (mainContent) {
          this.isScrolled = window.scrollY > 100;
        }
      }
    }
  }
}
</script>
